import { ReactElement, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Typography } from '@mui/material'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'

import { TitleScreen } from 'src/v3/core/types'
import { useAppSelector } from 'src/store/hooks'
import DangerousHtml from 'src/v3/components/dangerous-html'
import axios, { pluckData } from 'src/utilities/http-client'
import { selectSessionByID } from '../live.slice'

export default (): ReactElement => {
  let { sessionID } = useParams()
  let session = useAppSelector(selectSessionByID(sessionID ?? ''))
  let [titleScreen, setTitleScreen] = useState<TitleScreen | null>(null)

  useEffect(() => {
    if (session && !titleScreen) {
      axios
        .get(
          `/api/v2/admin/live-class/title-screen?titleScreenID=${session.classTitleScreen}`,
        )
        .then(pluckData)
        .then(setTitleScreen)
    }
  }, [session, titleScreen])

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        height: '100%',
        backgroundImage: `url("${import.meta.env.VITE_CLOUDFRONT_URL}/public/${session?.classImageName}")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        color: 'white', // ensure text color is readable
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'black',
          opacity: 0.8,
        }}
      ></div>
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          padding: '20px', // adjust padding as needed
        }}
      >
        <div className="p-4">
          <Typography sx={{ fontFamily: 'smileAndWave' }} variant="h4">
            {session?.className}
          </Typography>
          <Button size="large" variant="outlined" className="mt-5 bg-white">
            <a target="_blank" href={session?.classMeetingUrl}>
              <PlayArrowIcon color="primary" />{' '}
              <Typography className="d-inline" color="primary">
                Play
              </Typography>
            </a>
          </Button>
          <div className="mt-2">
            <DangerousHtml
              htmlVal={titleScreen?.content ?? ''}
              isEncoded={true}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
